import { jsx, jsxs } from 'react/jsx-runtime';
import { Text } from '../../display/Text/Text.es.js';
import { Link } from '../../navigation/Link/Link.es.js';
import { s as styles } from '../../../SubscriptionForm.module-BPLbtSf-.mjs';

const DisclaimerText = ({ color = "primary", termsLink = "https://zapier.com/tos", textType = "Body1", privacyLink = "https://zapier.com/privacy" }) => {
  const textColor = color === "primary" ? "GrayWarm9" : "PrimeWhite";
  return jsx("div", { className: styles.ctaDisclaimer, "data-zds": true, children: jsxs(Text, { tag: "p", type: textType, color: textColor, children: ["By signing up, you agree to Zapier’s", " ", jsx(Link, { href: termsLink, color, children: "Terms of Service" }), " ", "and", " ", jsx(Link, { href: privacyLink, color, children: "Privacy Policy" }), "."] }) });
};

export { DisclaimerText };
//# sourceMappingURL=DisclaimerText.es.js.map
